import { render, staticRenderFns } from "./BitFamilySection.vue?vue&type=template&id=59e8e3a9&scoped=true"
import script from "./BitFamilySection.vue?vue&type=script&lang=js"
export * from "./BitFamilySection.vue?vue&type=script&lang=js"
import style0 from "./BitFamilySection.vue?vue&type=style&index=0&id=59e8e3a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e8e3a9",
  null
  
)

export default component.exports